module.exports = __webpack_public_path__ + "9fddab52ea68a703800dda1d65576708.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic_1@2x.png
// module id = 212
// module chunks = 1